export default __webpack_public_path__ + "static/media/11.065c4f54.jpg";